import { Box, Modal } from "@mui/material";

/**
 * Extracts the video ID from a YouTube URL.
 * @param url - The YouTube URL from which to extract the video ID.
 * @returns The video ID if found, otherwise null.
 */
function extractVideoId(url: string) {
        
        // Regular expression to match YouTube URLs
        const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    
        // Extract video ID using the regex
        const match = url.match(youtubeRegex);
    
        // If there's a match, return the video ID
        if (match && match[1]) {
            return match[1];
        }
    
        // If no match, return null or handle it as needed
        return null;
}

/**
 * Renders a modal component that displays a summary and topics.
 *
 * @param modalOpen - A boolean indicating whether the modal is open or not.
 * @param handleModalClose - A function to handle the modal close event.
 * @param chatOption - The chat option selected.
 * @param modalData - An object containing the summary and topics data.
 * @param youtubeURL - The YouTube URL to embed in the modal (if chatOption is "youtube").
 * @returns The SummaryModal component.
 */
const SummaryModal = ({modalOpen, handleModalClose, chatOption, modalData, youtubeURL}: any) => {

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{
                position: "absolute" as "absolute",
                top: "5%",
                left: "10%",

                width: "80%",
                height: "90%",
                overflow: "auto",
                bgcolor: "background.paper",
                boxShadow: 10,
                p: 3,
            }}>{
                chatOption === "youtube" &&
                <iframe
                    width="100%"
                    height="480"
                    src={`https://www.youtube.com/embed/${extractVideoId(youtubeURL)}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                    />
            }
                <h2>Summary</h2>
                <pre style={{
                    whiteSpace: "pre-wrap",
                    // fontFamily: "segoeui",
                    fontSize: "16px",
                    fontWeight: 400
                }}>{modalData.summary}</pre>
                <br />
                <h2>Topics</h2>
                <pre style={{
                    whiteSpace: "pre-wrap",
                    // fontFamily: "segoeui",
                    fontSize: "16px"
                }}>{modalData.topics}</pre>
            </Box>
        </Modal>)
}

export default SummaryModal;